import React, { useState, useEffect } from 'react';
import FormInput from '../../components/elements/form_input';
import Button from '../../components/elements/button';
import { Doctor, Filter} from '../../assets/icons';
import LoadingSpinner from '../../components/elements/LoadingSpinner';
import '../../assets/css/pages/doctors.css';
import { useNavigate } from 'react-router-dom';
import { doctorApi } from '../../network/apis/doctors';

const Doctors = () => {
    const [doctors, setDoctors] = useState([
        {
            id: 1,
            name: "Dr. Sarah Johnson",
            image: "/doctors/sarah.jpg",
            city: "New York",
            reviews: 128,
            rating: 4.8,
            experience: "10+ years",
            specialization: "Aquatic Veterinary Medicine"
        },
    ]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showFilters, setShowFilters] = useState(false);
    const [filters, setFilters] = useState({
        // country: '',
        city: '',
        specialization: '',
        // experience: ''
    });

    const navigate = useNavigate();

    useEffect(() => {
        fetchDoctors();
    }, []);

    const fetchDoctors = async () => {
        try {
            setLoading(true);
            const response = await doctorApi.getDoctors();
        console.log("Response:", response.data);
        // Handle paginated response
        if (response.data) {
            setDoctors(response.data);
        } else {
            setDoctors([]);
        }
    } catch (error) {
        setError(error.message || 'Failed to fetch doctors');
        setDoctors([]);
    } finally {
        setLoading(false);
    }
    };

    if (loading) {
        return <LoadingSpinner />;
    }

    if (error) {
        return (
            <div className="error-container">
                <h2>Something went wrong</h2>
                <p>{error}</p>
                <Button 
                    text="Try Again" 
                    variant="primary" 
                    onClick={fetchDoctors}
                />
            </div>
        );
    }



    return (
    <div className="doctors-page">
        <div className="doctors-header">
                <div className="header-content">
                    <h1>Find an Aquatic Veterinarian</h1>
                    <p>Connect with experienced aquaculture health specialists</p>
                </div>
                {doctors.length > 0 ? (
                <div className="search-section">
                    <div className="search-bar">
                        <FormInput 
                            type="text"
                            placeholder="Search doctors..."
                            icon="search"
                        />
                        <button 
                            className={`filter-toggle ${showFilters ? 'active' : ''}`}
                            onClick={() => setShowFilters(!showFilters)}
                        >
                            <img src={Filter} alt="Filter" />
                        </button>
                        <Button 
                            text="Search"
                            variant="primary"
                        />
                    </div>

                    {showFilters && (
                        <div className="expanded-filters">
                            <div className="filter-grid">
                                {/* <FormInput 
                                    type="select"
                                    placeholder="Select Country"
                                    value={filters.country}
                                    onChange={(e) => setFilters({...filters, country: e.target.value})}
                                /> */}
                                <FormInput 
                                    type="select"
                                    placeholder="Select City"
                                    value={filters.city}
                                    onChange={(e) => setFilters({...filters, city: e.target.value})}
                                />
                                <FormInput 
                                    type="select"
                                    placeholder="Select Specialization"
                                    value={filters.specialization}
                                    onChange={(e) => setFilters({...filters, specialization: e.target.value})}
                                />
                                {/* <FormInput 
                                    type="select"
                                    placeholder="Experience Level"
                                    value={filters.experience}
                                    onChange={(e) => setFilters({...filters, experience: e.target.value})}
                                /> */}
                            </div>
                        </div>
                    )}
                </div>
                ) : (
                    <></>
                )}
            </div>
                

            <div className="doctors-grid">
            {doctors.length > 0 ? (
                doctors.map(doctor => (
                    <div key={doctor.id} className="doctor-card">
                        <div className="doctor-image">
                            <img src={doctor.image} alt={doctor.name} />
                        </div>
                        {/* <div className="doctor-rating">
                            <img src={Star} /> {doctor.rating}
                            <p className="reviews"><small>({doctor.reviews} reviews)</small></p>
                        </div> */}
                        <div className="doctor-info">
                            <h3>{doctor.first_name +" "+ doctor.last_name}</h3>
                            <p>{doctor.specialization}</p>
                            <p className='city'><small>{doctor.city || ""}</small></p>
                            {/* <p className="reviews">{doctor.reviews} reviews</p> */}
                        </div>
                        <div className="doctor-actions">
                            <Button 
                                text="View Profile"
                                variant="primary"
                                onClick={()=> navigate(`/doctor/${doctor.id}`)}
                            />
                            {/* <Button 
                                text="View Profile"
                                variant="outline"
                            /> */}
                        </div>
                    </div>
                ))
            ) : (
                <div className="empty-state">
                    <div className="empty-state-content">
                        <img src={Doctor} alt="No doctors" className="empty-icon" />
                        <h3>No Doctors Found</h3>
                        <p>We couldn't find any doctors</p>
                        {Object.values(filters).some(value => value !== '') && (
                            <Button 
                                text="Clear Filters"
                                variant="secondary"
                                onClick={() => {
                                    setFilters({
                                        country: '',
                                        city: '',
                                        district: '',
                                        experience: ''
                                    });
                                    fetchDoctors();
                                }}
                            />
                        )}
                    </div>
                </div>
            )}
            </div>
        </div>
    );
};

export default Doctors;